import { Option, SetPrdType } from "../controller/OrderController";

/**
 * 주문대기
 */
export const ORDER_WAIT_STATUS = 0;

/**
 * 주문접수
 */
export const ORDER_READY_STATUS = 1;

/**
 * 조리완료
 */
export const ORDER_COM_COOK_STATUS = 2;

/**
 * 배달시작
 */
export const ORDER_START_DEL_STATUS = 6;

/**
 * 배달완료
 */
export const ORDER_COM_DEL_STATUS = 7;

/**
 * 서빙완료
 */
export const ORDER_COM_SERVING_STATUS = 3;

/**
 * 주문완료
 */
export const ORDER_COM_STATUS = 5;

/**
 * 주문취소
 */
export const ORDER_CANCLE_STATUS = 4;

// 바로고
// 배달 접수
export const RIDER_ACCEPTED = "ACCEPTED";
// 배차
export const RIDER_ALLOCATED = "ALLOCATED";
// 배차 취소
export const RIDER_ALLOCATION_CANCELED = "ALLOCATION_CANCELED";
// 배차 변경
export const RIDER_ALLOCATION_CHANGED = "ALLOCATION_CHANGED";
// 픽업지 도착
export const RIDER_ARRIVED = "ARRIVED";
// 픽업 완료
export const RIDER_PICKUP_FINISHED = "PICKUP_FINISHED";
// 드랍 완료
export const RIDER_DROP_FINISHED = "DROP_FINISHED";

// knockknock
export const APP_NAME_KNOCKKNOCK = "KNOCK";
export const APP_NAME_THROO = "THROO";

export const THROO_ORDER_STATE_COLOR = {
  STANDBY: "standby",
  CONFIRMED: "confirmed",
  PREPARED: "prepared",
  CONCLUDE: "conclude",
  CUSTOMER_CANCELLED: "customer_cancelled",
  STORE_CANCELLED: "store_cancelled",
};

export const ORDER_SERVICE = {
  POS_ORDER: 1,
  THROO_ORDER: 2,
  BAEMIN_ORDER: 3,
  COUPANG_ORDER: 4,
  YOGIYO: 5,
  KIOSK: 6,
  TABLE_ORDER: 7,
  KNOCKKNOCK_ORDER: 8,
};

export const PAY_REQUEST_MESSAGE_TYPE = "pay";
export const CANCEL_PAY_REQUEST_MESSAGE_TYPE = "cancel_pay";
export const ORDER_COMPLETE_MESSAGE_TYPE = "order_complete";
export const ECHO_MESSAGE_TYPE = "echo";

export type postMessageType = {
  type: "cancel_pay" | "pay" | "order_complete" | "echo";
  data: postMessagePaymentRequestType | {};
};

export type postMessagePaymentRequestType = {
  amount: number;
  requested_at: Date;
};

export type OrderChildType = {
  order_seq: number;
  order_status: number;
  next_order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  delivery_address: string;
  delivery_address_detail: string;
  delivery_estimated_time: number;
  delivery_prepared_time?: number;
  delivery_type: number;
  delivery_tip: number;
  room_tip: number;
  bill_number: string;
  order_nr: null;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  inquiry: string;
  created_at: string | null;
  confirmed_at: string | null;
  prepared_at: string | null;
  picked_up_at: string | null;
  completed_at: null | string;
  delivery_expected_at: null | string;
  delivery_completed_at: null | string;
  cancelled_at: string | null;
  cancel_description: string | null;
  hotel_name: string;
  hotel_phone_number: string;
  store_discount_amount: number;
  com_discount_amount: number;

  detail: {
    product_id: number;
    product_seq: number;
    set_product_seq: number;
    product_name: string;
    is_set: number;
    has_option: number;
    product_status: number;
    product_price: number;
    product_discount_name: string;
    product_discount_amount: number;
    product_quantity: number;
    product_tax: number;
    product_tax_name: string | null;
    product_tax_rate: string;
    product_total_amount: number;
    request_id: null;
    request_message: null;
    prepared_at: string | null;
    cancelled_at: string | null;
    cancel_description: string | null;
    set_prd_type_list: SetPrdType[];
    options: Option[];
  }[];
};

export type KnockOrderDeliveryInfoType = {
  deliveryStatus: string;
  deliveryManPhoneNumber: string | null;
};

export type KnockOrderType = {
  app_name: "KNOCK";
  store_name: string;
  order_id: string;
  table_area_nr: number;
  table_nr: number;
  is_active: number;
  is_complete: number;
  completed_at: string | null;
  created_at: string;
  child: OrderChildType[];
  store_id: number;
  parent_store_id: number;
  payment?: paymentRealmType[];
  deliveryInfo?: KnockOrderDeliveryInfoType;
};

export type OrderType = KnockOrderType | ThrooOrderType;
export type OrderItemType = KnockOrderItemType | ThrooOrderType;
export type KnockOrderItemType = {
  app_name: "KNOCK";
  store_name: string;
  order_id: string;
  store_id: number;
  table_area_nr: number;
  table_nr: number;
  parent_store_id: number;
  child: OrderChildType;
  payment?: paymentRealmType[];
  delivery_info?: KnockOrderDeliveryInfoType;
};

export type ThrooOrderType = {
  app_name: "THROO";
  row_num: string;
  order_sequence: string;
  store_id: number;
  order_id: number;
  order_nr: string;
  uuid: string;
  state_id: number;
  payment_state_id: number;
  type_id: number;
  dist_remaining: null;
  order_lat: string;
  order_lng: string;
  user_id: number;
  ccard_id: null;
  inquiry: string;
  user_phone_number: string;
  store_name: string;
  store_prepare_time: number;
  arrival_time: string;
  created_at: string;
  updated_at: string;
  confirmed_at: null;
  order_created_at: string;
  prepared_at: null;
  picked_up_at: null;
  cancelled_at: null;
  cancel_description: string;
  noti_type: number;
  noti_type_msg: string;
  pickup_type: number;
  pickup_speed: number;
  delivery_address: string;
  delivery_obtain_type: string;
  delivery_door_code: string;
  dist_remaining_nrm: string;
  type_code: string;
  type_name: string;
  state_color: string;
  user_full_name: string;
  license_number: string;
  order_total_quantity: number;
  order_total_amount_incl: string;
  order_total_amount_excl: string;
  order_total_amount_show: string;
  order_discount_amount: string;
  order_discount_amount_show: string;
  order_total_amount_org: string;
  order_total_amount_org_show: string;
  car_nr: string;
  car_style: string;
  arrival_in_minutes: number;
  arrival_in_minutes_show: string;
  arrival_in_seconds: number;
  arrival_norm: string;
  store_prepare_time_show: string;
  prepare_in_seconds: number;
  estimated_prepare_at_ts: number;
  noti_parking_arrival: number;
  noti_parking_prepare: number;
  noti_auto_order_cancel: number;
  noti_pos_order_cancel: number;
  noti_order_confirm: number;
  noti_order_prepared_aft: number;
  noti_order_prepared_bef: number;
  noti_concluded: number;
};

// export type OrderInfoType = KnockOrderType[];

// export type OrderInfoType = {
//   order:KnockOrderType;
//   payment:paymentRealmType[][] ;
// }

export type OrderDataType = {
  order_id: string;
  store_id: number;
  store_name: string;
  phone_number: string;
  order_status: number;
  created_at: string;
  confirmed_at: string;
  prepared_at: string;
  completed_at: string;
};

export type orderDetailOptionType = {
  option_id: number;
  option_type_id: number;
  option_type_name: string;
  option_name: string;
  option_price: number;
  created_at?: Date;
  updated_at?: Date;
};

export type orderDetailRealmType = {
  store_id: number;
  product_id: number;
  category_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set?: number;
  has_option?: number;
  product_status?: number;
  product_price: number;
  product_discount_name: string;
  product_discount_amount: number;
  product_quantity: number;
  product_tax_rate?: string;
  product_tax_name?: string;
  product_total_amount: number;
  product_type: number;
  request_id?: number;
  request_message?: string;
  prepared_at?: Date;
  cancelled_at?: Date;
  cancel_description?: string;
  created_at?: Date;
  updated_at?: Date;
  option_price?: number;
  options?: orderDetailOptionType[];
  products?: orderDetailRealmType[];
  set_options?: orderDetailRealmType[];
};

export type orderChildRealmType = {
  order_id: string;
  order_seq: number;
  order_status?: number;
  table_nr?: number;
  area_nr?: number;
  ordered_at?: Date;
  payment_type: number;
  payment_status?: number;
  bill_number?: string;
  order_nr?: string;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  prepared_at?: Date;
  picked_up_at?: Date;
  cancelled_at?: Date;
  cancel_description?: string;
  status?: number;
  created_at: Date;
  updated_at: Date;
  orderDetails: orderDetailRealmType[];
  order_complete: boolean;
  paid_at?: Date;
  detail?: orderDetailRealmType[];

  phone_number?: string;
  people_number?: number;
  child_number?: number;
  wait_yn?: boolean;
  wait_id?: string;
};

export type orderRealmType = {
  store_id: number;
  order_id: string;
  table_nr: number;
  area_nr: number;
  order_service: number;
  parent_store_id?: number;
  is_complete?: number;
  completed_at?: Date;
  status?: number;
  created_at: Date;
  updated_at: Date;
  orderChilds: orderChildRealmType[];
  payments: paymentRealmType[];
  discounts: number[];
  send_server: boolean;
};

export type paymentRealmType = {
  tran_result?: boolean;
  tran_msg?: string;
  payment_van_id?: string;
  store_id?: string | number;
  order_id?: string;
  bill_number?: string;
  order_seq?: string | number;
  pay_seq?: string | number;
  van_type?: string;
  tran_type?: string;
  pay_type?: string;
  easy_type?: string;
  response_code?: string;
  amount?: number;
  vat_amount?: number;
  service_amount?: number;
  installment?: number;
  approval_no?: string;
  approval_date?: string;
  org_payment_van_id?: string;
  org_approval_no?: string;
  org_approval_date?: string;
  cancel_fg?: number;
  issuer_code?: string;
  issuer_name?: string;
  acquirer_code?: string;
  acquirer_name?: string;
  store_no?: string;
  cat_id?: string;
  balance?: string;
  response_msg?: string;
  card_no?: string;
  card_type?: string;
  tran_management_no?: string;
  tran_serial_no?: string;
  occurrence_point?: string;
  available_point?: string;
  accumulated_point?: string;
  cashback_store?: string;
  cashback_approval_no?: string;
  dcc_flag?: string;
  device_number?: string;
  key_data?: string;
  store_data?: string;
  edc_flag?: string;
  gift_amt?: string;
  biz_no?: string;
  notice?: string;
  cash_type?: string;
  cash_no?: string;
  send_server?: boolean;
  created_at?: Date;
  order_created_at?: Date;
  updated_at?: Date;
  cancelled_at?: Date;
  payment_at?: Date;
  org_payment_at?: Date;
};

export type RequestOrderProudctType = {
  store_id: number;
  order_id: string;
  table_nr: number;
  table_area_nr: number;
  parent_store_id: number | null;
  is_active: number;
  order: {
    order_seq: number;
    order_status: number;
    ordered_at: string;
    bill_number: string;
    order_nr: null | number;
    order_type: number;
    order_service: number;
    total_amount_org: number;
    discount_amount: number;
    tax: number;
    total_amount_incl: number;
    payment_type: number;
    payment_status: number;
    products: {
      category_id: number;
      product_id: number;
      product_name: string;
      has_option: number;
      is_set: number;
      product_seq: number;
      product_price: number;
      product_discount_name: string;
      product_discount_amount: number;
      product_status: number;
      product_quantity: number;
      product_tax: number;
      product_tax_name: null | string;
      product_tax_rate: string;
      product_total_amount: number;
      request_id: null | number;
      request_message: null | string;
      options?: {
        option_id: number | string;
        option_name: string;
        option_price: number;
      }[];
      set_options?: {
        product_id: number;
        product_name: string;
        has_option: number;
        is_set: number;
        product_seq: number;
        product_price: number;
        product_status: number;
        product_discount_name: string;
        product_discount_amount: number;
        product_quantity: number;
        product_tax: number;
        product_tax_name: null | string;
        product_tax_rate: string;
        product_total_amount: number;
        request_id: null | number;
        request_message: null | string;
        options?: {
          option_id: number | string;
          option_name: string;
          option_price: number;
        }[];
      }[];
      products?: {
        product_id: number;
        product_name: string;
        has_option: number;
        is_set: number;
        product_seq: number;
        product_price: number;
        product_status: number;
        product_discount_name: string;
        product_discount_amount: number;
        product_quantity: number;
        product_tax: number;
        product_tax_name: null | string;
        product_tax_rate: string;
        product_total_amount: number;
        request_id: null | number;
        request_message: null | string;
        options?: {
          option_id: number | string;
          option_name: string;
          option_price: number;
        }[];
      }[];
    }[];
  };
  payments: paymentRealmType[];
};

export type SoldoutMenuType = {
  product_id: number;
  store_id: number;
  is_set: number;
};
